import { InputLabel, TextField, TextFieldProps } from '@mui/material';
import { useTranslate } from 'react-admin';

export const GrayTextFieldWithUpperLabel = (props: TextFieldProps) => {

  const translate = useTranslate();

  return (
    <>
      <InputLabel className="input-label">
        {translate(typeof props.label === 'string' ? props.label : '', { _: props.label })}
      </InputLabel>
      <TextField {...props} label={false} inputProps={{ style: { backgroundColor: '#f1f1f1', borderRadius: '5px' } }}
        sx={{
          '& fieldset': {
            border: 'none',
          },
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#f1f1f1 !important',
          },
        }}
      />
    </>
  );

};
